
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/recenzie",
      function () {
        return require("private-next-pages/[region]/[resort]/recenzie.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/recenzie"])
      });
    }
  